module.exports = __webpack_public_path__ + "static/media/icon_extension_stl.093d60eb.svg";